export type ExcelCellValue = string | number | boolean;

export type ReceiveValidationKind = "none" | "boolean" | "number" | "enum";

export type SheetOrigin = {
  startRow: number;
  startColumn: number;
};

export type SpeckleWorkbookWriteTarget = SheetOrigin & {
  worksheetName: string;
  selectedAddress: string;
  targetAddress?: string;
};

export type ReceiveFieldRow = {
  rowId: number;
  path: string;
  value: ExcelCellValue;
  type: string;
  originalValue: ExcelCellValue;
  editable: boolean;
  field: string;
  unit: string;
  status: string;
  description: string;
  validationKind: ReceiveValidationKind;
  allowedValues: string[];
  minimum?: number;
  maximum?: number;
  validationMessage: string;
};

type ReceiveLayoutConfig = {
  headers: readonly string[];
  columnCount: number;
  valueColumnOffset: number;
};

const RECEIVE_VISIBLE_HEADERS = ["#", "Path", "Field", "Value", "Unit", "Status", "Description"] as const;

export const RECEIVE_LAYOUT_CONFIG: ReceiveLayoutConfig = {
  headers: RECEIVE_VISIBLE_HEADERS,
  columnCount: RECEIVE_VISIBLE_HEADERS.length,
  valueColumnOffset: RECEIVE_VISIBLE_HEADERS.indexOf("Value"),
};
